import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Check, X } from "lucide-react";

interface IncompleteWorkoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinueAnyway: () => void;
  onGoBack: () => void;
  incompleteExercises: Array<{
    name: string;
    incompleteSets: number;
    totalSets: number;
  }>;
}

export function IncompleteWorkoutModal({
  isOpen,
  onClose,
  onContinueAnyway,
  onGoBack,
  incompleteExercises
}: IncompleteWorkoutModalProps) {
  const { t } = useTranslation();
  const totalIncomplete = incompleteExercises.reduce((sum, ex) => sum + ex.incompleteSets, 0);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-warning/20 rounded-full flex items-center justify-center">
            <AlertTriangle className="h-8 w-8 text-warning" />
          </div>
          <DialogTitle className="text-xl font-bold text-center">
            {t('components.incompleteWorkout.title')}
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6 py-4">
          <div className="text-center">
            <p className="text-sm text-muted-foreground mb-4">
              {t('components.incompleteWorkout.summary', { count: totalIncomplete })}
            </p>
            
            <div className="space-y-2 bg-accent/50 rounded-lg p-4 text-left">
              {incompleteExercises.map((exercise, index) => (
                <div key={index} className="flex justify-between items-center text-sm">
                  <span className="font-medium">{exercise.name}</span>
                  <span className="text-muted-foreground">
                    {exercise.incompleteSets}/{exercise.totalSets} · {t('components.incompleteWorkout.rowSuffix', { count: exercise.incompleteSets })}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center text-sm text-muted-foreground">
            {t('components.incompleteWorkout.question')}
          </div>

          <div className="flex flex-col gap-3">
            <Button 
              onClick={onGoBack}
              className="w-full gap-2"
            >
              <Check className="h-4 w-4" />
              {t('components.incompleteWorkout.goBack')}
            </Button>
            
            <Button 
              variant="outline" 
              onClick={onContinueAnyway}
              className="w-full gap-2"
            >
              <X className="h-4 w-4" />
              {t('components.incompleteWorkout.finishAnyway')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}